<template>
	<div class="research">
		
		<div class="top">
			<div class="l_c">
				<div class="title">青海青少年研究</div>
				<div class="line"></div>
			</div>
			<div class="r_c" @click="$util.goPage('news',27)">更多 ></div>
		</div>
		
		<div class="carcon f-row-b align-start">
			<!-- <a href="http://192.168.0.125:9005/unified-portal/sys/common/pdf/pdfPreviewIframe/temp/29期(1)_1640222176683.pdf" target = '_blank'>测试;</a> -->
			<!-- $util.goPage('newDetail',27,list[0].id) -->
			<div class="l_c" @click="openUrl(list[0].file)">
				<img v-if='list&&list.length>0' :src="list[0].img?$fileAccessHttpUrl(list[0].img.split(',')[0]):defimg" class="pinter"/>
				<img v-else :src="defimg" class="pinter"/>
			</div>
			<div class="r_c">
				<!-- $util.goPage('newDetail',27,item.id) -->
				<div class="signle" v-for="(item,index) in list" :key="index" @click="openUrl(item.file)">
					<img :src="item.img?$fileAccessHttpUrl(item.img.split(',')[0]):$defult" />
					<div class="overf-elli w-100" :title="item.title">
						<!-- {{item.title?item.title:''}} -->
						{{$util.overfElli(item.title,len)}}
					</div>
				</div>
			</div>
		</div>
		
		

	</div>
	
</template>

<script>

export default {
  props:['list','len'],
  data: function() {
		return {
		  defimg:require('../../assets/img/studiesbg@2x.png'),
		};
  },
  
  mounted() {
	
  },

  methods: {
    openUrl(url){ 
		// window.open(this.$baseUrl+'/sys/common/preview1/'+url)
		// url=this.$baseUrl+'/sys/common/pdf/pdfPreview?filePath='+url
		// console.log(666,url)
		url=this.$baseUrl+'/sys/common/pdf/pdfPreview?filePath='+url
		
		var link = document.createElement('a')
        link.style.display = 'none'
        link.href = url
        link.target = '_blank'
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
	}
  },
  
  
};
</script>

<style scoped="scoped" lang="scss">
	
.research{
	
	.top{
		height: 35px;
		display: flex;
		justify-content: space-between;
		border-bottom: 2px solid #F1F1F1;
		.l_c{
			.title{
				font-size: 18px;
				font-weight: bold;
				color: #BA0711;
			}		
			.line{
			   margin-top: 5px;
				width: 125px;
				height: 5px;
				background: #BA0711;
			}
		}
		.r_c{
			font-size: 14px;
			font-weight: 300;
			color: #BA0711;
			cursor: pointer;
		}
		
	}
	
	.carcon{
		margin-top: 40px;
		.l_c{
			flex: 1;
			display: flex;
			justify-content: center;
			img{
				height: 543px;
				width: 470px;
			}
		}
		.r_c{
			margin-top:110px;
			flex: 1;
			display: flex;
			flex-wrap: wrap;
			align-items: center;
			.signle{
				display: flex;
				flex-direction: column;
				align-items: center;
				margin-left: 40px;
				width: calc(33.33% - 40px);
				overflow: hidden;
				img{
					cursor: pointer;
					max-height: 199px;
					width: 135px;
				}
				div{
					cursor: pointer;
					margin-top: 5px;
					font-size: 16px;
					padding: 10px;
					font-weight: 400;
					color: #333333;
				}
			}
			
			// .signle:hover img{
			// 	height: 210px;
			// 	width: 150px;
			// }
			// .signle:hover span{
			// 	font-size: 20px;
			// }
			.signle:hover{
				transform: translateY(-10px);
				box-shadow:  5px 5px 8px rgba(0, 0, 0, 0.3);
				div{
					// transform:scale(1.2);
				}
			}
			
		}
	}
	
	
}

</style>
